import {
  UserProfileResponse,
  getUserProfile,
} from '@reception-web/common/api/app'
import { AxiosError } from 'axios'
import useSWR from 'swr'

import { useAosToken } from './useAosToken'

export const useUserProfileApi = () => {
  const aosToken = useAosToken()
  const { data, error } = useSWR<UserProfileResponse, AxiosError<Error>>(
    aosToken ? `/aos/user-profile` : null,
    () =>
      getUserProfile({ headers: { Authorization: `Token ${aosToken}` } }).then(
        (res) => res.data
      )
  )

  return {
    data,
    error,
  }
}
